var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('ccMenu')],1),_c('el-container',[_c('el-header',{attrs:{"height":"80"}},[_c('ccHead')],1),_c('el-main',[_c('ccMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }